import { render } from "./TechniciansListView.vue?vue&type=template&id=32a12500"
import script from "./TechniciansListView.vue?vue&type=script&lang=js"
export * from "./TechniciansListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__